import { render, staticRenderFns } from "./TargetsV2a.vue?vue&type=template&id=d38d59ae&scoped=true&lang=pug&"
import script from "./TargetsV2a.vue?vue&type=script&lang=js&"
export * from "./TargetsV2a.vue?vue&type=script&lang=js&"
import style0 from "./TargetsV2a.vue?vue&type=style&index=0&id=d38d59ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d38d59ae",
  null
  
)

export default component.exports